import type { BulkInviteSuccessResponse } from '@atlassian/invite-people/types';

export const isBulkInviteSuccessResponse = (
	response: unknown,
): response is BulkInviteSuccessResponse => {
	return response !== null && typeof response === 'object' && 'invited' in response;
};
